import { render, staticRenderFns } from "./ProjectSubmissionForm.vue?vue&type=template&id=c3f3f22c"
import script from "./ProjectSubmissionForm.vue?vue&type=script&lang=js"
export * from "./ProjectSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports